// Single source of truth untuk seluruh konten portofolio.
// Semua halaman membaca dari file ini — update CV cukup di sini.

export const profile = {
  name: "Raihanaldy Ash-Shafa",
  firstName: "Raihanaldy",
  lastName: "Ash-Shafa",
  initials: "RA",
  headline: "Full-Stack & AI Developer",
  tagline: ["Full-Stack & AI Developer", "Enterprise web · Mobile · Computer Vision"],
  location: "Semarang, Central Java, Indonesia",
  locationShort: "Semarang, ID",
  email: "rhnaldy4@gmail.com",
  phone: "+62 895-1088-9127",
  phoneLink: "+6289510889127",
  whatsapp: "https://wa.me/6289510889127",
  linkedin: "https://www.linkedin.com/in/raihan-aldy/",
  github: "https://github.com/RaihanAldy",
  githubUser: "RaihanAldy",
  instagram: "https://www.instagram.com/rhnaldy_",
  cvFile: "/CV_Raihanaldy_Ash-Shafa.pdf",
  current: {
    role: "IT Web Developer",
    company: "CV Perdana Teknosindo",
  },
  summary:
    "Computer Engineering graduate with hands-on experience developing 5+ full-stack and AI-driven applications across web and mobile platforms. I build scalable enterprise systems, multi-tenant architectures and real-time processing tools with React.js, Node.js, CodeIgniter, Flutter and TensorFlow — with a strong focus on cloud services, hardware-software integration and strict regulatory data compliance.",
  statement:
    "I build enterprise systems and AI-powered apps — from customs-compliant ERP to offline face recognition.",
};

export const highlights = [
  { value: "5+", label: "Full-stack & AI apps shipped" },
  { value: "3.52", label: "GPA · Computer Engineering" },
  { value: "250h", label: "KADA advanced digital training" },
  { value: "1", label: "Peer-reviewed publication (JIPI)" },
];

export const experience = [
  {
    period: "Mar 2026 — Present",
    current: true,
    company: "CV Perdana Teknosindo",
    role: "IT Web Developer",
    location: "Semarang, Indonesia",
    points: [
      "Headed the design and development of enterprise-grade web applications, managing the full-stack lifecycle from architecture design to deployment.",
      "Championed high-compliance data engineering and complex business-logic validation, ensuring high availability and system reliability across projects.",
      "Delivered client-specific feature requests through custom database migrations, automated workflows and analytical reporting modules.",
    ],
    stack: ["CodeIgniter 4", "MariaDB", "PHP", "REST API", "PM2"],
  },
  {
    period: "Sep 2025 — Nov 2025",
    company: "Korea-ASEAN Digital Academy (KADA)",
    role: "Digital Talent Trainee",
    location: "Cikarang, Indonesia",
    points: [
      "Selected among 60 participants for an intensive 250-hour advanced digital technology program covering AI ethics, backend systems and cloud computing.",
      "Developed an end-to-end digital prototype addressing ASEAN–Korea collaboration challenges within 2 weeks.",
      "Implemented backend and cloud services that improved system scalability by 50%, and presented the final solution at Demo Day to leading Indonesian and Korean companies.",
    ],
    stack: ["AI Ethics", "Backend", "Cloud Computing", "AWS", "React.js"],
  },
];

export const projectCategories = [
  { key: "all", label: "All" },
  { key: "enterprise", label: "Enterprise & Web" },
  { key: "ai", label: "AI & Computer Vision" },
  { key: "mobile", label: "Mobile" },
];

export const projects = [
  {
    slug: "qibris-erp-kb",
    name: "Qibris ERP KB",
    subtitle: "Multi-tenant customs ERP for bonded zones",
    role: "Lead Full-Stack Developer · via CV Perdana Teknosindo",
    period: "Mar 2026 — Feb 2027",
    status: "In development",
    location: "Semarang",
    categories: ["enterprise"],
    featured: true,
    summary:
      "A multi-tenant, web-based ERP that automates customs compliance and resource planning for active bonded-zone (Kawasan Berikat) companies in Indonesia.",
    points: [
      "Integrating the CEISA 4.0 Host-to-Host API for real-time customs documents (BC 2.3, 2.7, 3.0 and more) with a fail-safe revert-to-draft recovery mechanism.",
      "Designed a high-compliance Hybrid Material Issue service that blocks imported items from backflushing to keep inventory 100% aligned with DJBC regulations.",
      "Built traceability data models for material linkage and BC balance, with idempotent schema sync across every tenant.",
      "Cross-channel notifications (WhatsApp API, SMTP email, in-app) and high-performance exports with PhpSpreadsheet and mPDF.",
    ],
    metrics: [
      { value: "H2H", label: "CEISA 4.0 integration" },
      { value: "100%", label: "DJBC data alignment" },
      { value: "Multi", label: "tenant architecture" },
    ],
    stack: ["CodeIgniter 4", "MariaDB", "CEISA 4.0 API", "PhpSpreadsheet", "mPDF", "WhatsApp API"],
    links: [],
  },
  {
    slug: "recca",
    name: "RECCA",
    subtitle: "Enterprise offline face recognition",
    role: "React.js & Computer Vision Engineer",
    period: "Sep 2025 — Nov 2025",
    location: "Cikarang",
    categories: ["ai", "enterprise"],
    featured: true,
    summary:
      "An offline-first face recognition system for enterprise environments, built during the KADA program.",
    points: [
      "Engineered an offline-first recognition pipeline with Python and OpenCV.",
      "Cut inference time down to 0.6 ms per detection.",
      "Reached 85% recognition accuracy under fully offline conditions.",
    ],
    metrics: [
      { value: "0.6 ms", label: "per detection" },
      { value: "85%", label: "offline accuracy" },
    ],
    stack: ["Python", "OpenCV", "React.js"],
    links: [],
  },
  {
    slug: "gov-building-rental",
    name: "Government Building Rental System",
    subtitle: "Role-based facility booking platform",
    role: "React.js & Express.js Full-Stack Developer",
    period: "Apr 2025 — Jun 2025",
    location: "Semarang",
    categories: ["enterprise"],
    summary:
      "A role-based booking platform that streamlines reservations of government facilities end to end.",
    points: [
      "Co-developed the role-based booking flow for citizens and administrators.",
      "Integrated Firebase Authentication and the QRIS payment gateway, reducing manual verification by 30%.",
      "Built an admin dashboard with QR-code validation to speed up on-site operations.",
    ],
    metrics: [
      { value: "−30%", label: "manual verification" },
      { value: "QRIS", label: "payment gateway" },
    ],
    stack: ["React.js", "Express.js", "Firebase Auth", "QRIS"],
    links: [],
  },
  {
    slug: "durian-detector",
    name: "Durian Detector",
    subtitle: "On-device AI fruit classification",
    role: "Flutter AI Developer",
    period: "Nov 2024 — Jan 2025",
    location: "Semarang",
    categories: ["ai", "mobile"],
    summary:
      "A Flutter app with an on-device TensorFlow Lite model for real-time durian classification — designed for standalone, offline use in the field.",
    points: [
      "Integrated TensorFlow Lite into Flutter for real-time classification.",
      "Trained on a 4,000-image dataset, reaching 70% accuracy.",
      "Optimized the model to run fully offline for agricultural use.",
    ],
    metrics: [
      { value: "70%", label: "accuracy" },
      { value: "4K", label: "image dataset" },
    ],
    stack: ["Flutter", "Dart", "TensorFlow Lite"],
    links: [],
  },
  {
    slug: "foodkcal",
    name: "FoodKcal",
    subtitle: "Calorie tracking from a photo",
    role: "Computer Vision Engineer",
    period: "Aug 2024 — Sep 2024",
    location: "Semarang",
    categories: ["ai", "mobile"],
    summary:
      "Image-based calorie estimation using Mask R-CNN, delivered through a Telegram bot for real-time use. Published in JIPI (2024).",
    points: [
      "Engineered the image-processing pipeline with Python and Mask R-CNN.",
      "Processed a 15,000-image dataset to reach 78% accuracy.",
      "Wrapped the model in a Telegram bot for accessible, real-time processing.",
    ],
    metrics: [
      { value: "78%", label: "accuracy" },
      { value: "15K", label: "image dataset" },
    ],
    stack: ["Python", "Mask R-CNN", "Telegram Bot"],
    links: [{ label: "Read publication", url: "https://doi.org/10.29100/jipi.v10i1.6972" }],
  },
];

export const education = {
  main: {
    period: "2021 — 2025",
    institution: "Dian Nuswantoro University",
    degree: "Bachelor of Computer Engineering",
    location: "Semarang, Indonesia",
    gpa: "3.52 / 4.00",
    coursework: [
      "Data Structures & Algorithms",
      "Machine Learning",
      "Computer Vision",
      "Cloud Computing",
      "Software Engineering",
    ],
    description:
      "Specialized in software development, algorithms and system architecture, with a strong foundation in computer systems, networking and software engineering principles.",
  },
  training: {
    period: "Sep 2025 — Nov 2025",
    institution: "Korea-ASEAN Digital Academy (KADA)",
    degree: "Digital Talent Program · 250 hours",
    location: "Cikarang, Indonesia",
    description:
      "Selected among 60 participants for an intensive program covering AI ethics, backend systems, DevOps, UI/UX and cloud services — closing with a Demo Day in front of Indonesian and Korean companies.",
  },
  earlier: [
    { period: "2019 — 2021", institution: "SMA Negeri 9 Semarang", degree: "Senior High School · Science" },
    { period: "2016 — 2019", institution: "SMP Islam Hidayatullah", degree: "Junior High School" },
    { period: "2010 — 2016", institution: "SDIT Assalamah Ungaran", degree: "Elementary School" },
  ],
};

export const publication = {
  title: "FoodKcal — Mobile Application for Calorie Tracking and Nutrition Management",
  venue: "JIPI (Jurnal Ilmiah Penelitian dan Pembelajaran Informatika)",
  year: "2024",
  authors: "Raihanaldy Ash-Shafa & Pulung Nurtantio Andono",
  note: "Implemented a calorie-prediction algorithm using Mask R-CNN, achieving 78% accuracy.",
  url: "https://doi.org/10.29100/jipi.v10i1.6972",
  doi: "10.29100/jipi.v10i1.6972",
};

export const certifications = [
  { title: "BNSP Certified Web Developer", issuer: "Badan Nasional Sertifikasi Profesi", date: "Jan 2025" },
  { title: "TOEFL CFLT — Score 483", issuer: "English proficiency", date: "Feb 2025" },
  { title: "KADA Digital Talent", issuer: "Korea-ASEAN Digital Academy", date: "Nov 2025" },
];

export const activities = [
  "Speaker — phishing awareness socialization at SMPN 39 Semarang",
  "Speaker — basic coding through games training at SMAN 1 Semarang",
  "Participant — National Programming Competition 2023",
  "Member — Computer Engineering Student Association",
];

export const languages = [
  { name: "Indonesian", level: "Native" },
  { name: "English", level: "Intermediate" },
];

// Resume khusus per peran (link lama tetap dipertahankan)
export const resumes = [
  {
    title: "Full CV 2026",
    role: "Full-Stack & AI Developer",
    description: "Latest general CV — enterprise ERP, AI projects, publication and certifications.",
    url: "/CV_Raihanaldy_Ash-Shafa.pdf",
    primary: true,
  },
  {
    title: "Mobile Developer",
    role: "Flutter · Firebase · REST API",
    description: "Cross-platform mobile focus with performant, user-friendly apps.",
    url: "https://drive.google.com/file/d/1-6BNwQSnE-Ayys6C-YLBfIsu0Exd02ki/view?usp=sharing",
  },
  {
    title: "Fullstack Developer",
    role: "React · Node.js · Express · MongoDB",
    description: "Scalable web applications from frontend to backend with cloud deployment.",
    url: "https://drive.google.com/file/d/1eYFKMNMZAEg5TNB-s_pOOHk-VGfZrqu-/view?usp=sharing",
  },
  {
    title: "Data Scientist",
    role: "Python · TensorFlow · Machine Learning",
    description: "Machine learning and computer vision — turning raw data into working models.",
    url: "https://drive.google.com/file/d/1wj6ukVy0SMgG_gWsY4B9kRRVGM0ZMkDo/view?usp=sharing",
  },
];
